import Axios from 'axios';
import { buildQueryParams } from 'utils/ParamsBuilder';
import { SOURCE, MYUUID, EPOCH, SIGNATURE } from 'utils/constants/Cdp';

const baseUrl = `${process.env.REACT_APP_STORE_URL}/miscellaneous/v1/cms/customer-data-portals`;

const instance = Axios.create({
  baseURL: baseUrl
});

class CustomerDataPlatformService {
  getHeaders() {
    return {
      'device-id': MYUUID,
      source: SOURCE,
      epoch: EPOCH,
      signature: SIGNATURE,
      Authorization: `Bearer ${localStorage.getItem('token')}`
    };
  }

  audienceGroupList(params) {
    const queryParams = buildQueryParams(params);
    return instance
      .get(`/audience-groups/?${queryParams.toString()}`, {
        headers: this.getHeaders()
      })
      .then((respone) => {
        return respone;
      })
      .catch((err) => {
        return err.response;
      });
  }

  downloadAudieceGroup(id) {
    return instance
      .get(`/audience-groups/${id}/download`, {
        headers: this.getHeaders()
      })
      .then((respone) => {
        return respone;
      })
      .catch((err) => {
        return err.response;
      });
  }
  storeAudienceGroup(body) {
    return instance
      .post(`/audience-groups/`, body, {
        headers: this.getHeaders()
      })
      .then((respone) => {
        return respone;
      })
      .catch((err) => {
        return err.response;
      });
  }
  putAudienceGroupById(id, body) {
    return instance
      .put(`/audience-groups/${id}`, body, {
        headers: this.getHeaders()
      })
      .then((respone) => {
        return respone;
      })
      .catch((err) => {
        return err.response;
      });
  }
  audienceGroupById(id) {
    return instance
      .get(`/audience-groups/${id}`, {
        headers: this.getHeaders()
      })
      .then((respone) => {
        return respone;
      })
      .catch((err) => {
        return err.response;
      });
  }
  deleteById(id) {
    return instance
      .delete(`/audience-groups/${id}`, {
        headers: this.getHeaders()
      })
      .then((respone) => {
        return respone;
      })
      .catch((err) => {
        return err.response;
      });
  }
  masterFilterList() {
    return instance
      .get(`/master-filters`, {
        headers: this.getHeaders()
      })
      .then((respone) => {
        return respone;
      })
      .catch((err) => {
        return err.response;
      });
  }
}

export default new CustomerDataPlatformService();
